var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-card',{staticClass:"omapi-personalization__rules"},_vm._l((_vm.categoriesToShow),function(category){return _c('personalization-category',{key:category.slug,attrs:{"search":_vm.search,"category":category,"rules":_vm.rulesToShow(category.slug)},on:{"clearSearch":function($event){return _vm.$emit('clearSearch')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }